import { useAction, useMutation, useQuery } from 'convex/react'
import { makeFunctionReference } from 'convex/server'
import type { SyncPreview } from '../../../../convex/lib/sync_preview'
import { ReservationSyncPreview } from '../components/reservations/ReservationSyncPreview'
import { api } from '@convex/_generated/api'
import type { Id } from '@convex/_generated/dataModel'
import ReservationOperationsView from './ReservationOperationsView'

const previewRef = makeFunctionReference<'action', { reservationId: Id<'sales_reservations'>; runId: string; nativePropertyId: number; expectedRevision: number }, SyncPreview>('reservationsyncpreview:preview')

export default function ReservationOperations({ enabled, selected, onSelect, testRunId }: {
  testRunId?:string; enabled: boolean; selected: string | null; onSelect: (id: string | null) => void
}) {
  const overview = useQuery(api.reservationops.overview, {testRunId})
  const detail = useQuery(api.reservationops.detail, selected ? { reservationId: selected as Id<'sales_reservations'>,testRunId } : 'skip')
  const extend = useAction(api.reservationops.extend)
  const payment = useAction(api.reservationops.recordPayment)
  const completeSale = useAction(api.reservationops.completeSale)
  const review = useMutation(api.reservationops.requestReview)
  const resolve = useAction(api.reservationops.resolveReview)
  const preview = useAction(previewRef)
  return <><ReservationOperationsView enabled={enabled} overview={overview} detail={detail} selected={selected}
    onSelect={onSelect} onExtend={async args => { await extend({ ...args, reservationId: args.reservationId as Id<'sales_reservations'> }) }}
    onPayment={async args => { await payment({ ...args, reservationId: args.reservationId as Id<'sales_reservations'> }) }}
    onCompleteSale={async args=>{await completeSale({...args,reservationId:args.reservationId as Id<'sales_reservations'>})}}
    onResolve={args => resolve({ ...args, reservationId: args.reservationId as Id<'sales_reservations'>, reviewId: args.reviewId as Id<'sales_review_requests'> })}
    onReview={args => review({ ...args, reservationId: args.reservationId as Id<'sales_reservations'> })} />
    {testRunId && detail && selected === detail.id && <ReservationSyncPreview key={JSON.stringify([testRunId, detail.id, detail.revision])}
      runId={testRunId} reservationId={detail.id} revision={detail.revision}
      onPreview={({ nativePropertyId }) => preview({ reservationId: detail.id as Id<'sales_reservations'>, runId: testRunId, expectedRevision: detail.revision, nativePropertyId })} />}
  </>
}
